module.exports = __webpack_public_path__ + "static/media/icon-music.a85abb29.svg";